const isEmptyObject = (value)=>{
    for(const prop in value){
        if (Object.prototype.hasOwnProperty.call(value, prop)) {
            return false;
        }
    }
    return true;
};

export { isEmptyObject };
//# sourceMappingURL=isEmptyObject.mjs.map
